import SubpageHero from "@/components/site/SubpageHero";
import Garten from "@/components/site/Garten";
import FuetterungAuswilderung from "@/components/site/FuetterungAuswilderung";
import Marquee from "@/components/site/Marquee";
import Kontakt from "@/components/site/Kontakt";

export default function TippsPage() {
  return (
    <>
      <SubpageHero
        testId="page-tipps"
        eyebrow="Gutes tun für Igel"
        titleLines={["Garten, Futter", "& Auswilderung"]}
        accent="text-brand-green"
        intro="Schon kleine Dinge machen einen großen Unterschied. So wird dein Garten zum sicheren Zuhause, du fütterst richtig und begleitest kleine Wildlinge zurück in die Freiheit."
      />
      <Garten />
      <Marquee />
      <FuetterungAuswilderung />
      <Kontakt />
    </>
  );
}
